import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({ selector: '[autofocusDirective]' })
export class AutofocusDirective implements AfterViewInit {
  private elementRef = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @Input() autofocusDirective: boolean;

  ngAfterViewInit(): void {
    if(this.autofocusDirective){
      setTimeout(() => this.elementRef.nativeElement.focus(), 200);
    }
  }
}
